export const AUTH_TOKEN = 'authToken';

export enum AuthTypeEnum {
  Admin = 'admin',
  CompanyAdmin = 'company_admin',
  Technician = 'technician',
}
